// components/admin/EditDeviceForm.tsx
import { useEffect, useState, forwardRef, useImperativeHandle } from "react"; // 🆕 added forwardRef + useImperativeHandle
import { Form, Spinner } from "react-bootstrap";
import { DeviceDataItem } from "hooks/useDevicesDataList";
// import authApi from "services/authApi";
import http from "services/httpClient";

// interface Client {
//   id: number;
//   name: string;
// }

// 🆕 define the exposed handle interface
export interface EditDeviceFormHandle {
  save: () => Promise<Partial<DeviceDataItem> | undefined>;
}

// ⬇️ wrap the component in forwardRef
const EditDeviceForm = forwardRef<EditDeviceFormHandle, {
    device: DeviceDataItem | null;
    onChange?: (data: {
    device_name: string;
    client_id: number;
    conn: number;
    param_count: number;
    }) => void;
    }>(({ device, onChange }, ref) => {
    const [device_name, setDeviceName] = useState("");
    const [client_id, setClientId] = useState<number>(0);
    const [conn, setConn] = useState<number>(1);
    const [param_count, setParamCount] = useState<number>(0);
    // const [clients, setClients] = useState<Client[]>([]);

    useEffect(() => {
        if (device) {
        setDeviceName(device.device_name);
        setClientId(device.client_id);
        setConn(device.conn || 1);
        setParamCount(device.param_count || 0);
        }
    }, [device]);

    // useEffect(() => {
    //   http.get("/clients")
    //     .then((res) => setClients(res.data))
    //     .catch(() => setClients([]));
    // }, []);

    useEffect(() => {
        onChange?.({ device_name, client_id, conn, param_count });
    }, [device_name, client_id, conn, param_count]);

  // 🆕 expose save() to parent via ref
  useImperativeHandle(ref, () => ({
    async save() {
      if (!device) return;
      const updated = {
        id: device.id,
        device_name,
        client_id,
        conn,
        param_count,
      };

      await http.patch(`/device/${device.id}`, updated);

      return updated;
    }
  }));

  if (!device) return <Spinner animation="border" />;

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Device Name</Form.Label>
        <Form.Control
          type="text"
          value={device_name}
          onChange={(e) => setDeviceName(e.target.value)}
        />
      </Form.Group>
      {/* <Form.Group className="mb-3">
        <Form.Label>Client</Form.Label>
        <Form.Select
          value={client_id}
          onChange={(e) => setClientId(Number(e.target.value))}
        >
          <option value="">Select client</option>
          {clients.map((client) => (
            <option key={client.id} value={client.id}>
              {client.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Conn</Form.Label>
        <Form.Select
          value={conn}
          onChange={(e) => setConn(Number(e.target.value))}
        >
          <option value={1}>FTP</option>
          <option value={2}>MQTT</option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
      <Form.Label>Param Count</Form.Label>
      <Form.Select
        value={param_count}
        onChange={(e) => setParamCount(Number(e.target.value))}
      >
        {Array.from({ length: 30 }, (_, i) => i + 1).map((num) => (
          <option key={num} value={num}>
            {num}
          </option>
        ))}
      </Form.Select>
    </Form.Group> */}
    </>
  );
});

export default EditDeviceForm;
